import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useModalControls, BaseModal } from '@components/modals';
import ManageClientDataForm from '../partials/ManageClientDataForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAddClient',
  setup(__props) {

const { close } = useModalControls();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseModal), {
    title: _ctx.$t('pages.clients.create-label'),
    size: "lg",
    "no-body-padding": ""
  }, {
    default: _withCtx(() => [
      _createVNode(ManageClientDataForm, {
        class: "p-4",
        onClose: _unref(close),
        onSave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save', $event)))
      }, null, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})